module.exports = __webpack_public_path__ + "img/ide-data.f0e41b03.svg";